export const COMMENT_SLOT_ALREADY_TAKEN = 'This timestamp has already been selected.';
